import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import PeopleIcon from '@mui/icons-material/People';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import StarIcon from '@mui/icons-material/Star';

import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import SportsBasketballOutlinedIcon from '@mui/icons-material/SportsBasketballOutlined';
import RedeemOutlinedIcon from '@mui/icons-material/RedeemOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import MusicNoteOutlinedIcon from '@mui/icons-material/MusicNoteOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export const connectSchoolTagIcons = {
  star: <StarIcon />,
  money: <AttachMoneyOutlinedIcon />,
  people: <PeopleIcon />,
  rocket: <RocketLaunchOutlinedIcon />,
  localShipping: <LocalShippingOutlinedIcon />,
  work: <WorkOutlineOutlinedIcon />,
  time: <AccessTimeOutlinedIcon />,
  sports: <SportsBasketballOutlinedIcon />,
  redeem: <RedeemOutlinedIcon />,
  favorite: <FavoriteBorderOutlinedIcon />,
  location: <FmdGoodOutlinedIcon />,
  chat: <ChatBubbleOutlineOutlinedIcon />,
  music: <MusicNoteOutlinedIcon />,
  file: <AttachFileOutlinedIcon />,
  settings: <SettingsOutlinedIcon />,
  shield: <ShieldOutlinedIcon />,
  sell: <SellOutlinedIcon />,
  bolt: <BoltOutlinedIcon />,
  calender: <CalendarMonthIcon />,
};
